import { UNSAFE_expValNoExposure } from '@confluence/feature-experiments';

export const getCommentsDataManagerExperimentAttributes = () => {
	return {
		newDataManagerEnabled: UNSAFE_expValNoExposure(
			'cc_comments_new_comments_data_manager',
			'isEnabled',
			false,
		),
	};
};
